import webshop from '@wwdev/webshop';
import Checkout from "./Checkout";
import Bindings from "@wwdev/webshop/bindings";
import Variants from "@wwdev/webshop/variants";
import SearchRequest from "@wwdev/product/SearchRequest";

import Product from '@wwdev/product';
import ProductAmountInput from "../../components/product/amount-input";

if (Product.hasOwnProperty('filters')) {
    Product.filters.afterCallback = function () {
        this.resetScroll();
        new ProductAmountInput({
            scope: '.product-card-component'
        });

    }
    Product.filters.beforeCallback = function () {
        SearchRequest.request.search_extended = jQuery('input[name=search_extended]').is(':checked');

    }
}

webshop.basket.init();
webshop.shipping.init();

Checkout.init();

Bindings.init();

Variants.init();
